<form [id]="formId()" [formGroup]="sendFormService.sendForm()" [bitSubmit]="submit">
  @if (!loading) {
    @if (!sendDisabled() && !editing()) {
      <bit-card class="bv-send-link-card">
        <div bitTypography="h4">{{ "sendLink" | i18n }}</div>
        <div
          class="tw-text-muted tw-mt-2 tw-mb-4 tw-truncate"
          bitTypography="body2"
          aria-hidden="true"
        >
          {{ sendLink() }}
        </div>
        <button
          class="tw-w-full"
          bitButton
          type="button"
          showToast
          buttonType="primary"
          startIcon="bwi-clone"
          [appCopyClick]="sendLink()"
          [valueLabel]="'sendLink' | i18n"
        >
          {{ "copy" | i18n }}
        </button>
      </bit-card>
    }
    <app-bv-send-details
      [editing]="editing()"
      (openPasswordGenerator)="openPasswordGenerator.emit()"
    ></app-bv-send-details>
  }
</form>
